const ONE_MINUTE = 60
const ONE_HOUR = ONE_MINUTE * 60
const ONE_DAY = ONE_HOUR * 24
const ONE_MONTH = ONE_DAY * 30
const ONE_YEAR = ONE_DAY * 365

type RelativeTimeInput = string | number | Date

const getTimestampMs = (timestamp: RelativeTimeInput) => {
	if (timestamp instanceof Date) {
		return timestamp.getTime()
	}

	if (typeof timestamp === 'number') {
		return timestamp > 1e12 ? timestamp : timestamp * 1000
	}

	return new Date(timestamp).getTime()
}

const getRelativeTime = (timestamp: RelativeTimeInput) => {
	const pastMs = getTimestampMs(timestamp)

	if (Number.isNaN(pastMs)) {
		return ''
	}

	const diffInSeconds = Math.max(0, Math.floor((Date.now() - pastMs) / 1000))

	if (diffInSeconds < ONE_MINUTE) return `${diffInSeconds}s`
	if (diffInSeconds < ONE_HOUR) return `${Math.floor(diffInSeconds / ONE_MINUTE)}m`
	if (diffInSeconds < ONE_DAY) return `${Math.floor(diffInSeconds / ONE_HOUR)}h`
	if (diffInSeconds < ONE_MONTH) return `${Math.floor(diffInSeconds / ONE_DAY)}d`
	if (diffInSeconds < ONE_YEAR) return `${Math.floor(diffInSeconds / ONE_MONTH)}mo`
	return `${Math.floor(diffInSeconds / ONE_YEAR)}y`
}

export default getRelativeTime
